<template>
  <section class="relaMonitor">
    <commonHeader title="线路实时监测信息" isMore @checkMore="checkMore" />
    <ul class="baseInfo">
      <li class="runTime">
        <img src="../img/run_img.png" alt="" />
        <div class="runTime_info">
          <span class="runTime_info_title">系统已安全运行</span>
          <div class="runTime_info_data">
            <span class="dateData">{{ runDay.days }}</span>
            <span class="dateUnit">天</span>
            <span class="dateData">{{ runDay.hours }}</span>
            <span class="dateUnit">时</span>
            <span class="dateData">{{ runDay.minutes }}</span>
            <span class="dateUnit">分</span>
            <span class="dateData">{{ runDay.seconds }}</span>
            <span class="dateUnit">秒</span>
          </div>
        </div>
      </li>
      <li class="deviceInfo">
        <img src="../img/device_img.png" alt="" />
        <ul class="deviceInfo_con">
          <li>
            <span class="deviceInfo_title">设备总数</span>
            <span class="deviceInfo_num">{{ deviceCountInfo['total'] || 0 }}<em>台</em></span>
          </li>
          <li>
            <span class="deviceInfo_title">交流</span>
            <span class="deviceInfo_num">{{ deviceCountInfo['AC'] || 0 }}<em>台</em></span>
          </li>
          <li>
            <span class="deviceInfo_title">直流</span>
            <span class="deviceInfo_num">{{ deviceCountInfo['DC'] || 0 }}<em>台</em></span>
          </li>
        </ul>
      </li>
    </ul>
    <ul class="tabList">
      <li class="tabItem" @click="changeTab('DC')" :class="{ active: currentTab == 'DC' }">
        直流导线
      </li>
      <li class="tabItem" @click="changeTab('AC')" :class="{ active: currentTab == 'AC' }">
        交流导线
      </li>
    </ul>
    <div class="table-container">
      <div class="table-wrapper">
        <table class="monitor-table">
          <thead>
            <tr class="header-row">
              <th class="header-cell header-cell-left">设备名称</th>
              <th class="header-cell" v-for="key in deviceKeys" :key="key">{{ key }}</th>
              <th class="header-cell header-cell-last">均值</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in tableData" :key="index" class="data-row">
              <td class="data-cell data-cell-name">
                {{ row.name }}
              </td>
              <td class="data-cell" v-for="key in deviceKeys" :key="key">
                {{ row[key] }}
              </td>
              <td class="data-cell data-cell-last">
                {{ row.average }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>
</template>

<script>
  import { timeFn } from 'utils'
  import commonHeader from '../commonHeader.vue'
  export default {
    components: {
      commonHeader
    },
    data() {
      return {
        runDay: {
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0
        },
        timer: null,
        currentTab: 'DC',
        tableData: [],
        deviceCountInfo: {},
        refreshTimer: null,
        deviceKeys: [] // 存储设备编号
      }
    },
    mounted() {
      this.getRunTime()
      this.getDeviceCountInfo()
      this.getTableData()
      this.refreshData()
    },
    methods: {
      checkMore() {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen()
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen()
        }
        this.$router.push({ name: 'spaceBarData' })
      },
      getRunTime() {
        this.$axiosget('operation/dictionaryType/queryByKey', {
          params: {
            key: 'runnedTime'
          }
        }).then(res => {
          if (res.data.status == 10000) {
            let data = res.data.data.list[0].value
            this.runDay = timeFn(new Date(data))
            this.runTime(data)
          }
        })
      },
      runTime(data) {
        if (this.timer) {
          clearInterval(this.timer)
        }
        this.timer = null
        this.timer = setInterval(() => {
          this.runDay = timeFn(new Date(data))
        }, 1000)
      },
      // 刷新数据
      refreshData() {
        if (this.refreshTimer) {
          clearInterval(this.refreshTimer)
        }
        this.refreshTimer = null
        this.refreshTimer = setInterval(() => {
          this.getTableData()
        }, 5 * 60 * 1000)
      },
      getDeviceCountInfo() {
        this.$axiosget('operation/gapStick/deviceCount').then(res => {
          if (res.data.status == 10000) {
            this.deviceCountInfo = res.data.data
          }
        })
      },
      changeTab(item) {
        this.currentTab = item
        this.getTableData()
        this.refreshData()
      },
      getTableData() {
        this.$axiosget('operation/gapStick/realtimeMonitor').then(res => {
          if (res.data.status == 10000) {
            // 将data转换为tableData格式
            this.tableData = this.convertDataToTableData(res.data.data[this.currentTab])
          }
        })
      },
      convertDataToTableData(data) {
        // 提取设备数据
        const deviceData = {}
        const deviceKeys = [] // 存储设备编号

        data.data.forEach(item => {
          // 获取对象中的所有key
          const keys = Object.keys(item)
          keys.forEach(key => {
            // 如果key以当前tab开头，说明是设备数据
            if (key.startsWith(this.currentTab)) {
              deviceData[key] = item[key]
              // 如果还没有添加到deviceKeys中，则添加
              if (!deviceKeys.includes(key)) {
                deviceKeys.push(key)
              }
            }
          })
        })

        // 对设备编号进行排序，确保顺序一致
        deviceKeys.sort()

        // 构建tableData，name字段保持写死
        const tableData = [
          {
            name: '环境温度',
            average: data.avgTemperature
          },
          {
            name: '导线温度',
            average: data.avgWireTemperature
          },
          {
            name: '负荷电流',
            average: data.avgCurrentValue
          },
          {
            name: '舞动幅度',
            average: data.avgScope
          },
          {
            name: '环境湿度',
            average: data.avgHumidity
          }
        ]

        // 为每个表格行添加设备数据
        tableData.forEach((row, rowIndex) => {
          deviceKeys.forEach(key => {
            // 根据不同的行类型获取对应的属性值
            let value = 0
            if (rowIndex === 0) {
              // 环境温度
              value = deviceData[key] ? deviceData[key].temperature : 0
            } else if (rowIndex === 1) {
              // 导线温度
              value = deviceData[key] ? deviceData[key].avgTemperature : 0
            } else if (rowIndex === 2) {
              // 负荷电流
              value = deviceData[key] ? deviceData[key].avgCurrentValue : 0
            } else if (rowIndex === 3) {
              // 舞动幅度
              value = deviceData[key] ? deviceData[key].scope : 0
            } else if (rowIndex === 4) {
              // 环境湿度
              value = deviceData[key] ? deviceData[key].humidity : 0
            }

            // 动态添加设备数据到行对象
            row[key] = value
          })
        })

        // 存储设备键值，供模板使用
        this.deviceKeys = deviceKeys

        return tableData
      }
    },
    beforeDestroy() {
      if (this.refreshTimer) {
        clearInterval(this.refreshTimer)
      }
      if (this.timer) {
        clearInterval(this.timer)
      }
    }
  }
</script>

<style lang="less" scoped>
  .relaMonitor {
    .baseInfo {
      height: 6.49vh;
      margin-top: 7.41vh;
      padding: 0 0.21rem 0 0.18rem;
      display: flex;
      align-items: center;

      & > li {
        flex: 1;
        height: 100%;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        display: flex;
        align-items: center;
        padding-left: 0.17rem;

        img {
          width: 0.57rem;
          height: auto;
          margin-right: 0.08rem;
        }
      }

      .runTime {
        background-image: url('../img/run_bg.png');

        &_info {
          &_title {
            display: inline-block;
            width: 1.12rem;
            height: 1.85vh;
            text-align: center;
            background-color: #00bf5a;
            border-radius: 0.02rem;
            font-family: MicrosoftYaHei;
            font-size: 1.11vh;
            font-style: italic;
            line-height: 1.85vh;
            letter-spacing: 0.01rem;
            color: #fff;
          }

          &_data {
            margin-top: 0.74vh;
            .dateData {
              font-family: 'Impact';
              font-size: 1.67vh;
              font-style: italic;
              color: #fff;
              text-shadow: 0 0 0.1rem #5e8392, 0 0 0.1rem #5e8392, 0 0 0.1rem #5e8392,
                0 0 0.1rem #5e8392;
            }

            .dateUnit {
              font-family: MicrosoftYaHei;
              font-size: 1.11vh;
              font-style: italic;
              color: rgba(255, 255, 255, 0.8);
              text-shadow: 0 0 0.1rem #5e8392, 0 0 0.1rem #5e8392, 0 0 0.1rem #5e8392,
                0 0 0.1rem #5e8392;
            }
          }
        }
      }

      .deviceInfo {
        margin-left: 0.16rem;
        background-image: url('../img/device_bg.png');
        padding-right: 0.3rem;

        &_con {
          flex: 1;
          display: flex;
          justify-content: space-between;
          align-items: center;

          li {
            display: flex;
            flex-direction: column;

            .deviceInfo_title {
              font-family: MicrosoftYaHei;
              font-size: 1.11vh;
              color: #fff;
            }

            .deviceInfo_num {
              margin-top: 0.37vh;
              font-family: 'MicrosoftYaHei-Bold';
              font-weight: bold;
              font-size: 1.67vh;
              color: #00edff;

              em {
                margin-left: 0.05rem;
                font-family: MicrosoftYaHei;
                font-size: 1.11vh;
              }
            }
          }
        }
      }
    }

    .tabList {
      margin: 0.93vh 0.35rem 0 0.19rem;
      border-bottom: 0.01rem solid #254177;
      display: flex;
      align-items: center;

      li {
        width: 1.37rem;
        text-align: center;
        padding-bottom: 0.65vh;
        font-family: 'AdobeHeitiStd-Regular';
        font-size: 1.48vh;
        line-height: 1;
        color: #fff;
        cursor: pointer;
      }

      .active {
        color: #39a0ff;
        border-bottom: 0.02rem solid #39a0ff;
      }
    }

    .table-container {
      margin: 0.28vh 0.35rem 0 0.19rem;

      .monitor-table {
        width: 100%;
        border-collapse: collapse;
        border-spacing: 0;
      }

      .header-row,
      .data-row {
        height: 2.03vh;
        background-color: #21407b;
        border-radius: 0.06rem;
        font-family: AdobeHeitiStd-Regular;
        font-size: 1.3vh;
        color: #fff;
        border-bottom: 0.46vh solid #142953;
      }

      .data-cell {
        text-align: center;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/spacerBar/components/relaMonitor.vue